import { routerReducer, RouterState } from 'react-router-redux';
import { combineReducers, Reducer } from 'redux';
import {reducer as oidcReducer } from 'redux-oidc';
import generatorReducer, { IGeneratorState } from './generators';
import profileReducer, { IProfileState } from './profile';

function lastAction(state = null, action: any) {
  return action;
}

const reducer:Reducer = combineReducers({
    gen: generatorReducer,
    lastaction: lastAction,
    oidc: oidcReducer,
    routing: routerReducer,
    user: profileReducer
  }
)

export default reducer

interface ILastactionState {
  type: string,
  payload: {}
}

export interface IState {
  gen: IGeneratorState,
  lastaction: ILastactionState,
  oidc: any,
  routing: RouterState,
  user: IProfileState
}



// WEBPACK FOOTER //
// ./src/store/reducer/index.ts